// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2zbae","modalFooterButton":"ModalNotes_modalFooterButton__3mMMK"};